const isType = targetType => type => type === targetType;

export const isDate = isType('date');

export const isDateTimeLocal = isType('datetime-local');
